import { ContentContainer } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { ClientUserFiltersBar } from './users/ClientUserFiltersBar';
import { ClientUserList } from './users/ClientUserList';

type Props = {
  clientId: string;
};

export function UsersTab({ clientId }: Readonly<Props>) {
  const [reloadPage, setReloadPage] = useState(false);

  return (
    <ContentContainer>
      <ClientUserFiltersBar
        clientId={clientId}
        onReloadPage={() => setReloadPage(!reloadPage)}
      />
      <ClientUserList
        clientId={clientId}
        reloadPage={reloadPage}
      />
    </ContentContainer>
  );
}
